import React, { useState, useLayoutEffect, useEffect, useContext } from 'react';
import { Ordinazione, Passaggio } from '../App';
import '../Cibi/Cibi.css'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'

let car = [];

const Cibi = () => {
    const ContestoOrdinazione = useContext(Ordinazione)
    const Contesto = useContext(Passaggio)

    const [cibi, setcibi] = useState([])
    const [filtro, setFiltro] = useState('Tutti')
    const link = useNavigate()

    useEffect(() => { car = Contesto.ordine }, [Contesto.ordine]);

    useLayoutEffect(() => {
        controllaToken()
        ScaricaCibi();
    }, [])

    const controllaToken = () => {
        fetch(Contesto.url + "/contolloToken", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + sessionStorage.getItem("token")
            }
        })
            .then(response => response.json())
            .then((dati) => {
                if (dati.risultato == "ko" || dati.risultato == undefined) {
                    Swal.fire({ title: 'Login fallito. Riprova.', icon: 'warning', timer: 1500, showConfirmButton: false });
                    link("/")
                }
            })
    }

    const ScaricaCibi = () => {
        
        fetch(Contesto.url +`/getProdotti?citta_id=${sessionStorage.getItem('idCitta')}&locali_id=${sessionStorage.getItem('idLocale')}`)
            .then(response => response.json())
            .then(data => {
                setcibi({
                    Salato: data.cibi.salato,
                    Dolce: data.cibi.dolce,
                    Bevande: data.bevande,
                    Menu: data.menu
                })
            })
    }

    const creaOggettoOrdine = (el) => {
        let ordinazione = {
            idProd: el.id,
            prodotto: el.nome,
            prezzo: el.prezzo,
            qta: 1,
            idLocale: sessionStorage.getItem('idLocale')
        }
        Contesto.setordine(ordinaz => [...ordinaz, ordinazione])
        Contesto.settotale(totale => totale + el.prezzo)
    }

    const aggiungi = (el) => {
        let altroLocale = true
        let presente = false
        Swal.fire({ title: 'Articolo inserito nel carrello!', timer: 1500, showConfirmButton: false, icon: 'success', width: "65vw" })
        if (car.length !== 0) {
            if (car[0].idLocale === sessionStorage.getItem('idLocale')) {
                car.forEach(element => {
                    if (element.idProd === el.id) {
                        presente = true
                        element.qta += 1;
                        Contesto.settotale(totale => totale + el.prezzo)
                    }
                });
                if (!presente) creaOggettoOrdine(el)
                else Contesto.setordine(car)
            } else {
                altroLocale = false
                Swal.fire({ title: 'Puoi acquistare da un solo Locale!', timer: 1500, showConfirmButton: false, icon: 'warning', width: "65vw" })
            }
        } else creaOggettoOrdine(el)
        if (altroLocale) Contesto.setqta((qta) => qta + 1)
    }

    const renderCibi = () => {
        if (!cibi) return null;
        let list = [];

        const categorieMap = {
            Salato: 'Cibi',
            Dolce: 'Dolci',
            Bevande: 'Bevande',
            Menu: 'Menu'
        };

        Object.keys(categorieMap).forEach(catKey => {
            if (filtro === 'Tutti' || filtro === catKey) {
                const items = cibi[catKey];
                if (items && items.length > 0) {
                    list.push(<div key={`cat${catKey}`} className='categoria'>{categorieMap[catKey]}</div>);
                    items.forEach((el, i) => {
                        list.push(<div key={`${catKey}${i}`} className='pulsante'>
                            <div className='formattatesto'>{el.nome}</div>
                            <div className='formattainfo'>PREZZO: {el.prezzo}€</div>
                            <div className='aggiungi' onClick={() => aggiungi(el)}><div className='sposta'>+</div></div>
                        </div>);
                    });
                }
            }
        });
        return list;
    }

    return (
        <div className="cibiPage">
            <div className="contenitoreCibi">
                <div className="headingsContainer">
                    <h1>MENU DISPONIBILE</h1>
                    <div className="selectFiltroContainer">
                        <select value={filtro} onChange={(e) => setFiltro(e.target.value)}>
                            <option value="Tutti">Tutti</option>
                            <option value="Salato">Cibi</option>
                            <option value="Dolce">Dolci</option>
                            <option value="Bevande">Bevande</option>
                            <option value="Menu">Menu</option>
                        </select>
                    </div>
                </div>
                {renderCibi()}
            </div>
        </div>
    )
}

export default Cibi;